import { FC, memo } from 'react';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompletePageLayoutsQuery } from '@/modules/Pages';

interface Props extends AppAutocompleteComponentProps {
  siteId: string;
}

export const PageLayoutsAutocomplete: FC<Props> = memo(({ siteId, ...props }) => {
  return (
    <AppAutocomplete<typeof useAutocompletePageLayoutsQuery>
      { ...props }
      queryArgs={ [siteId] }
      options={
        (data) =>
          parseSelectData(data, {
            value: 'id',
            label: 'name'
          })
      }
      searchWithoutQuery
      notFoundDescription="Немає макетів для цього сайту"
      placeholder="Знайдіть макет для сторінки"
      query={ useAutocompletePageLayoutsQuery }
    />
  );
});
